<template>
  <section class="section">
    <div class="section-body">
      <div class="card" v-if="!isEdit && mode != 'edit'">
        <div class="card-header">
          <v-icon color="pink">search</v-icon>
          <h4>{{ $t("messages.general.searchShowInfo") }}</h4>
        </div>
        <div class="card-body">
          <v-card width="100%">
            <v-row>
              <v-col
                cols="10"
                style="padding-top: 0; padding-bottom: 0; padding-right: 0;text-align: right;"
              >
                <p style="color: red; margin: 0">*</p>
              </v-col>
              <v-col
                style="padding-top: 0; padding-bottom: 0; padding-right: 5px;"
              >
                <p style="margin:   s0">
                  {{ $t("messages.general.reqFields") }}
                </p>
              </v-col>
            </v-row>
          </v-card>
          <form>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label>{{ $t("messages.general.academicYear") }} </label>
                  </div>
                  <div class="col no-margin-padding">
                    <AcademicYear
                      :onChanged="onSelYearChanged"
                      :selectedVal="selYear"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label>{{ $t("messages.general.semester") }} </label>
                  </div>
                  <div class="col no-margin-padding">
                    <Semester
                      :onChanged="onSelSemesterChanged"
                      :selectedVal="selSemester"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div
              class="form-row flex-column justify-content-center align-items-center mt-5"
            >
              <div class="form-group">
                <div class="form-inline">
                  <button
                    type="button"
                    class="btn btn-primary btn-lg"
                    @click="goTo(-1, -1, 'edit')"
                  >
                    {{ $t("messages.general.search") }}</button
                  >&nbsp;&nbsp;&nbsp;
                  <button
                    type="button"
                    class="btn btn-primary btn-lg"
                    @click="handleCopyData()"
                  >
                    {{ $t("messages.general.copy") }}</button
                  >&nbsp;&nbsp;&nbsp;
                  <button
                    type="button"
                    class="btn btn-light btn-lg"
                    @click="handleClearScreen()"
                  >
                    {{ $t("messages.general.clearScreen") }}</button
                  >&nbsp;&nbsp;&nbsp;
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
      <div class="card" v-if="!isEdit && mode == 'edit'">
        <div class="card-header">
          <v-icon color="pink">description</v-icon>
          <h4>{{ $t("messages.general.showInfo") }}</h4>
        </div>
        <v-card width="100%">
          <v-row>
            <v-col
              cols="10"
              style="padding-top: 0; padding-bottom: 0; padding-right: 0;text-align: right;"
            >
              <p style="color: red; margin: 0">*</p>
            </v-col>
            <v-col
              style="padding-top: 0; padding-bottom: 0; padding-right: 5px;"
            >
              <p style="margin: 0">{{ $t("messages.general.reqFields") }}</p>
            </v-col>
          </v-row>
        </v-card>
        <form>
          <div class="information-block">
            <div class="row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 16em;">
                    <div>{{ $t("messages.general.academicYear") }}</div>
                  </div>
                  <div class="col no-margin-padding">
                    <div>{{ selYear }}</div>
                  </div>
                  <div class="col no-margin-padding">
                    <div></div>
                  </div>
                  <div class="col no-margin-padding">
                    <div></div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 16em;">
                    <div>{{ $t("messages.general.semester") }}</div>
                  </div>
                  <div class="col no-margin-padding">
                    <div>{{ selSemester }}</div>
                  </div>
                  <div class="col no-margin-padding">
                    <div></div>
                  </div>
                  <div class="col no-margin-padding">
                    <div></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="form-row flex-column justify-content-center align-items-center mt-5"
          >
            <div class="form-group" style="width: 100%">
              <div class="form-inline">
                <div
                  class="form-group"
                  style="width: 60%; justify-content: center;"
                >
                  <div class="form-inline">
                    <button
                      type="button"
                      class="btn btn-primary btn-lg"
                      @click="handleSelectPersonnel()"
                    >
                      {{ $t("messages.general.selectPersonnel") }}</button
                    >&nbsp;&nbsp;&nbsp;
                    <button
                      type="button"
                      class="btn btn-light btn-lg"
                      @click="goBack()"
                    >
                      {{ $t("messages.general.backhome") }}</button
                    >&nbsp;&nbsp;&nbsp;
                  </div>
                </div>
                <div
                  class="form-group"
                  style="width: 40%; justify-content: flex-end;"
                >
                  <div class="form-inline">
                    <button
                      type="button"
                      class="btn btn-primary btn-lg"
                      @click="deleteDataPersonal()"
                    >
                      {{ $t("messages.general.del") }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <v-card>
            <b-table
              bordered
              hover
              small
              responsive
              caption-top
              class="table table-striped text-center"
              :sort-by.sync="bTableSelectPersonnel.sortBy"
              :sort-desc.sync="bTableSelectPersonnel.sortDesc"
              :items="bTableSelectPersonnel.items"
              :fields="bTableSelectPersonnel.fields"
              :per-page="perPage"
              :current-page="currentPageSearch"
            >
              <template slot="table-caption">
                <div class="float-left">
                  <b class="mr-2">{{
                    $t("messages.general.table.paginationinfo")
                  }}</b>
                  <b-form-select
                    v-model="perPage"
                    :options="perPageOptions"
                    size="sm"
                    style="width:70px"
                  />
                </div>
                <b-pagination
                  class="float-right"
                  size="sm"
                  :total-rows="bTableSelectPersonnel.items.length"
                  v-model="currentPageSearch"
                  :per-page="perPage"
                />
                <div
                  v-if="bTableSelectPersonnel.items.length > 0"
                  class="float-right data-table-page-info"
                >
                  {{
                    Number(
                      currentPageSearch > 1
                        ? (currentPageSearch - 1) * perPage + 1
                        : currentPageSearch
                    ).toLocaleString()
                  }}
                  -
                  {{
                    Number(
                      currentPageSearch * perPage >
                        bTableSelectPersonnel.items.length
                        ? bTableSelectPersonnel.items.length
                        : currentPageSearch * perPage
                    ).toLocaleString()
                  }}
                  {{ $t("messages.general.fromRecords") }}
                  {{
                    Number(bTableSelectPersonnel.items.length).toLocaleString()
                  }}
                </div>
                <div
                  v-if="bTableSelectPersonnel.items.length <= 0"
                  class="float-right data-table-page-info"
                >
                  0 - 0
                  {{ $t("messages.general.fromRecords") }}
                  {{
                    Number(bTableSelectPersonnel.items.length).toLocaleString()
                  }}
                </div>
              </template>
              <template v-slot:head(actionSelpersonel)="">
                <input
                  type="checkbox"
                  id="chkDelAll"
                  @change="handleDelChkAll($event)"
                  :checked="
                    bTableSelectPersonnel.items.length > 0 &&
                      bTableSelectPersonnel.items.length ==
                        personelSelList.length
                  "
                />
              </template>
              <template v-slot:cell(actionSelpersonel)="data">
                <input
                  type="checkbox"
                  id="chkDel"
                  @change="handleDelChk($event, data)"
                  :checked="data.item.actionSelpersonel"
                />
              </template>
              <template slot="table-caption">
                <div
                  style="position: absolute; bottom: -65px; width: 100%; height: 65px; padding-top: 10px; border-color: #fff; box-shadow: 0 3px 1px -2px rgba(0,0,0,.2), 0 2px 2px 0 rgba(0,0,0,.14), 0 1px 5px 0 rgba(0,0,0,.12);"
                >
                  <div class="float-left">
                    <b class="mr-2">{{
                      $t("messages.general.table.paginationinfo")
                    }}</b>
                    <b-form-select
                      v-model="perPage"
                      :options="perPageOptions"
                      size="sm"
                      style="width:70px"
                    />
                  </div>
                  <b-pagination
                    class="float-right"
                    size="sm"
                    :total-rows="bTableSelectPersonnel.items.length"
                    v-model="currentPageSearch"
                    :per-page="perPage"
                    style="padding-top: 10px"
                  />
                  <div
                    v-if="bTableSelectPersonnel.items.length > 0"
                    class="float-right data-table-page-info"
                    style="padding-top: 14px"
                  >
                    {{
                      Number(
                        currentPageSearch > 1
                          ? (currentPageSearch - 1) * perPage + 1
                          : currentPageSearch
                      ).toLocaleString()
                    }}
                    -
                    {{
                      Number(
                        currentPageSearch * perPage >
                          bTableSelectPersonnel.items.length
                          ? bTableSelectPersonnel.items.length
                          : currentPageSearch * perPage
                      ).toLocaleString()
                    }}
                    {{ $t("messages.general.fromRecords") }}
                    {{
                      Number(
                        bTableSelectPersonnel.items.length
                      ).toLocaleString()
                    }}
                  </div>
                  <div
                    v-if="bTableSelectPersonnel.items.length <= 0"
                    class="float-right data-table-page-info"
                    style="padding-top: 14px"
                  >
                    0 - 0
                    {{ $t("messages.general.fromRecords") }}
                    {{
                      Number(
                        bTableSelectPersonnel.items.length
                      ).toLocaleString()
                    }}
                  </div>
                </div>
              </template>
            </b-table>
          </v-card>
        </form>
      </div>
    </div>
    <v-dialog v-model="dialogSelectPersonnel" max-width="70%">
      <v-card tile>
        <v-toolbar flat dense>
          <v-icon>build</v-icon>
          <v-toolbar-title>{{
            $t("messages.general.selectDataCoorSched")
          }}</v-toolbar-title>
          <div class="flex-grow-1"></div>
          <v-toolbar-items>
            <v-btn icon @click="dialogSelectPersonnel = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text dark>
          <div class="form-row">
            <div class="col no-padding-bottom">
              <div class="information-detail-white">
                <div class="col no-margin-padding" style="flex: 0 0 10em;">
                  <label>{{ $t("messages.general.identity") }}</label>
                </div>
                <div class="col no-margin-padding">
                  <div>
                    <input
                      v-model="dlgIdentity"
                      type="text"
                      class="form-control col mr-2"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="form-row">
            <div class="col no-padding-bottom">
              <div class="information-detail-white">
                <div class="col no-margin-padding" style="flex: 0 0 10em;">
                  <label>{{ $t("messages.general.fullname") }}</label>
                </div>
                <div class="col no-margin-padding">
                  <div>
                    <input
                      v-model="dlgFullname"
                      type="text"
                      class="form-control col mr-2"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="form-row">
            <div class="col no-padding-bottom">
              <div class="information-detail-white">
                <div class="col no-margin-padding" style="flex: 0 0 10em;">
                  <label>{{ $t("messages.general.underFac") }} </label><code style="background: none; box-shadow: none;"
                        >*</code
                      >
                </div>
                <div class="col no-margin-padding">
                  <Faculty
                    :onChanged="onSelUnderFacChanged"
                    :selectedVal="selunderFac"
                  />
                </div>
              </div>
            </div>
          </div>
          <div
            class="form-row flex-column justify-content-center align-items-center mt-5"
          >
            <div class="form-group">
              <div class="form-inline">
                <button
                  class="btn btn-primary btn-lg"
                  type="button"
                  @click="handleSearchPersonel()"
                >
                  {{ $t("messages.general.search") }}</button
                >&nbsp;&nbsp;&nbsp;
                <button
                  class="btn btn-primary btn-lg"
                  type="button"
                  @click="handleSelPersonnel(false)"
                  :disabled="this.personelList.length <= 0"
                >
                  {{ $t("messages.general.select") }}</button
                >&nbsp;&nbsp;&nbsp;
                <button
                  class="btn btn-light btn-lg"
                  type="button"
                  @click="handleSelPersonnel(true)"
                >
                  {{ $t("messages.general.backhome") }}</button
                >&nbsp;&nbsp;&nbsp;
              </div>
            </div>
          </div>
          <v-card>
            <b-table
              bordered
              hover
              small
              responsive
              caption-top
              class="table table-striped text-center"
              :sort-by.sync="bTablePersonnel.sortBy"
              :sort-desc.sync="bTablePersonnel.sortDesc"
              :items="bTablePersonnel.items"
              :fields="bTablePersonnel.fields"
              :per-page="perPage"
              :current-page="currentPageSearch"
            >
              <template slot="table-caption">
                <div class="float-left">
                  <b class="mr-2">{{
                    $t("messages.general.table.paginationinfo")
                  }}</b>
                  <b-form-select
                    v-model="perPage"
                    :options="perPageOptions"
                    size="sm"
                    style="width:70px"
                  />
                </div>
                <b-pagination
                  class="float-right"
                  size="sm"
                  :total-rows="bTablePersonnel.items.length"
                  v-model="currentPageSearch"
                  :per-page="perPage"
                />
                <div
                  v-if="bTablePersonnel.items.length > 0"
                  class="float-right data-table-page-info"
                >
                  {{
                    Number(
                      currentPageSearch > 1
                        ? (currentPageSearch - 1) * perPage + 1
                        : currentPageSearch
                    ).toLocaleString()
                  }}
                  -
                  {{
                    Number(
                      currentPageSearch * perPage > bTablePersonnel.items.length
                        ? bTablePersonnel.items.length
                        : currentPageSearch * perPage
                    ).toLocaleString()
                  }}
                  {{ $t("messages.general.fromRecords") }}
                  {{ Number(bTablePersonnel.items.length).toLocaleString() }}
                </div>
                <div
                  v-if="bTablePersonnel.items.length <= 0"
                  class="float-right data-table-page-info"
                >
                  0 - 0
                  {{ $t("messages.general.fromRecords") }}
                  {{ Number(bTablePersonnel.items.length).toLocaleString() }}
                </div>
              </template>
              <template v-slot:head(action)="">
                <input
                  type="checkbox"
                  id="chkAllpersonel"
                  @change="handleChkAllPersonel($event)"
                  :checked="
                    bTablePersonnel.items.length > 0 &&
                      bTablePersonnel.items.length == personelList.length
                  "
                />
              </template>
              <template v-slot:cell(action)="data">
                <input
                  type="checkbox"
                  id="chkpersonel"
                  @change="handleChkPersonel($event, data)"
                  :checked="data.item.action"
                />
              </template>
              <template slot="table-caption">
                <div
                  style="position: absolute; bottom: -65px; width: 100%; height: 65px; padding-top: 10px; border-color: #fff; box-shadow: 0 3px 1px -2px rgba(0,0,0,.2), 0 2px 2px 0 rgba(0,0,0,.14), 0 1px 5px 0 rgba(0,0,0,.12);"
                >
                  <div class="float-left">
                    <b class="mr-2">{{
                      $t("messages.general.table.paginationinfo")
                    }}</b>
                    <b-form-select
                      v-model="perPage"
                      :options="perPageOptions"
                      size="sm"
                      style="width:70px"
                    />
                  </div>
                  <b-pagination
                    class="float-right"
                    size="sm"
                    :total-rows="bTablePersonnel.items.length"
                    v-model="currentPageSearch"
                    :per-page="perPage"
                    style="padding-top: 10px"
                  />
                  <div
                    v-if="bTablePersonnel.items.length > 0"
                    class="float-right data-table-page-info"
                    style="padding-top: 14px"
                  >
                    {{
                      Number(
                        currentPageSearch > 1
                          ? (currentPageSearch - 1) * perPage + 1
                          : currentPageSearch
                      ).toLocaleString()
                    }}
                    -
                    {{
                      Number(
                        currentPageSearch * perPage >
                          bTablePersonnel.items.length
                          ? bTablePersonnel.items.length
                          : currentPageSearch * perPage
                      ).toLocaleString()
                    }}
                    {{ $t("messages.general.fromRecords") }}
                    {{ Number(bTablePersonnel.items.length).toLocaleString() }}
                  </div>
                  <div
                    v-if="bTablePersonnel.items.length <= 0"
                    class="float-right data-table-page-info"
                    style="padding-top: 14px"
                  >
                    0 - 0
                    {{ $t("messages.general.fromRecords") }}
                    {{ Number(bTablePersonnel.items.length).toLocaleString() }}
                  </div>
                </div>
              </template>
            </b-table>
          </v-card>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogCopyFacSem" max-width="600px">
      <v-card tile>
        <v-toolbar flat dense>
          <v-icon>edit</v-icon>
          <v-toolbar-title>{{
            $t("messages.general.copyAcademicYear")
          }}</v-toolbar-title>
          <div class="flex-grow-1"></div>
          <v-toolbar-items>
            <v-btn icon @click="dialogCopyFacSem = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text dark>
          <div class="form-row">
            <div class="col no-padding-bottom">
              <div class="information-detail-white">
                <div class="col no-margin-padding" style="flex: 0 0 10em;">
                  <label
                    >{{ $t("messages.general.academicYear") }}
                    <code style="background: none; box-shadow: none;"
                      >*</code
                    ></label
                  >
                </div>
                <div class="col no-margin-padding">
                  <AcademicYear
                    :onChanged="onDlgSelYearChanged"
                    :selectedVal="dlgSelYear"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="form-row">
            <div class="col no-padding-bottom">
              <div class="information-detail-white">
                <div class="col no-margin-padding" style="flex: 0 0 10em;">
                  <label
                    >{{ $t("messages.general.semester") }}
                    <code style="background: none; box-shadow: none;"
                      >*</code
                    ></label
                  >
                </div>
                <div class="col no-margin-padding">
                  <Semester
                    :onChanged="onDlgSelSemesterChanged"
                    :selectedVal="dlgSelSemester"
                  />
                </div>
              </div>
            </div>
          </div>
          <div
            class="form-row flex-column justify-content-center align-items-center mt-5"
          >
            <div class="form-group">
              <div class="form-inline">
                <button
                  type="button"
                  class="btn btn-primary btn-lg"
                  @click="handelSelCopy()"
                >
                  {{ $t("messages.general.copy") }}</button
                >&nbsp;&nbsp;&nbsp;
              </div>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogConfirmSuccess" max-width="600px">
      <v-card tile>
        <v-toolbar flat dense color="light-green accent-3">
          <v-icon color="light-green darken-2">fa-check</v-icon>
          <v-toolbar-title style="color: green;"
            >&nbsp;{{
              $t("messages.reqRegister.confirmPopupText")
            }}</v-toolbar-title
          >
          <div class="flex-grow-1"></div>
          <v-toolbar-items>
            <v-btn icon @click="dialogConfirmSuccess = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text dark color="green accent-1">
          <br />
          <span v-html="successText" style="color: green;">{{
            successText
          }}</span>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogError" max-width="600px">
      <v-card tile>
        <v-toolbar flat dense color="red darken-3">
          <v-icon color="red lighten-5">fa-exclamation-circle</v-icon>
          <v-toolbar-title style="color: #ffebee;"
            >&nbsp;{{ dialogErrorTitle }}</v-toolbar-title
          >
          <div class="flex-grow-1"></div>
          <v-toolbar-items>
            <v-btn icon @click="dialogError = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text dark color="red accent-1">
          <br />
          <span style="color: red;" v-html="errorText">{{ errorText }}</span>
        </v-card-text>
      </v-card>
    </v-dialog>
  </section>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

import AcademicYear from "../components/Dropdown/AcademicYear";
import Semester from "../components/Dropdown/Semester";
// import Level from "@/components/Dropdown/Level.vue";
import Faculty from "@/components/Dropdown/Faculty.vue";
// import Department from "@/components/Dropdown/Department.vue";
import MasterDataProvider from "@/services/masterData_provider";
import EnrollProvider from "@/services/enroll_provider";

const masterDataProvider = new MasterDataProvider();
const enrollProvider = new EnrollProvider();

export default {
  name: "setCoorSchedForYearSem",
  components: {
    AcademicYear,
    Semester,
    // Level,
    Faculty,
    // Department,
  },
  data() {
    return {
      dialogSelectPersonnel: false,
      dialogCopyFacSem: false,
      selYear: 0,
      selSemester: 0,
      dlgSelYear: 0,
      dlgSelSemester: 0,
      selunderFac: 0,
      dlgIdentity: "",
      dlgFullname: "",
      selLvl: 0,
      selSection: "00",
      selConfirm: "0",
      courseCode: "",
      sections: [],
      items: [],
      personelList: [],
      personelSelList: [],
      mode: "",
      studentUnapproveList: [],
      bTable: {
        sortBy: "rowNumber",
        sortDesc: false,
        items: [],
        fields: [
          {
            key: "action",
            label: "",
            thClass: "align-middle",
            thStyle: "width: 50px",
            sortable: true,
          },
          {
            key: "rowNumber",
            label: this.$t("messages.general.seqOrder"),
            thClass: "align-middle",
            thStyle: "width: 80px",
            sortable: true,
          },
          {
            key: "ACADYEAR",
            label: this.$t("messages.general.academicYear"),
            thClass: "align-middle",
            tdClass: "text-center text-nowarp",
            sortable: true,
          },
          {
            key: "SEMESTER",
            label: this.$t("messages.general.semester"),
            thClass: "align-middle",
            tdClass: "text-center text-nowarp",
            sortable: true,
          },
        ],
      },
      bTableSelectPersonnel: {
        sortBy: "rowNumber",
        sortDesc: false,
        items: [],
        fields: [
          {
            key: "rowNumber",
            label: this.$t("messages.general.seqOrder"),
            thClass: "align-middle",
            thStyle: "width: 50px",
            sortable: true,
          },
          {
            key: "OFFICERCODE",
            label: this.$t("messages.general.identity"),
            thClass: "align-middle",
            thStyle: "width: 120px",
            sortable: true,
          },
          {
            key: "NAME",
            label: this.$t("messages.general.fullname"),
            thClass: "align-middle",
            thStyle: "width: 250px",
            tdClass: "text-left text-nowarp",
            sortable: true,
          },
          {
            key: "FACULTYNAME",
            label: this.$t("messages.general.underFac"),
            thClass: "align-middle",
            thStyle: "width: 150px",
            tdClass: "text-center text-nowarp",
            sortable: true,
          },
          {
            key: "GENDER",
            label: this.$t("messages.general.gender"),
            thClass: "align-middle",
            thStyle: "width: 150px",
            tdClass: "text-center text-nowarp",
            sortable: true,
          },
          {
            key: "actionSelpersonel",
            label: "",
            thClass: "align-middle",
            thStyle: "width: 80px",
            sortable: true,
          },
        ],
      },
      bTablePersonnel: {
        sortBy: "rowNumber",
        sortDesc: false,
        items: [],
        fields: [
          {
            key: "action",
            label: "",
            thClass: "align-middle",
            thStyle: "width: 80px",
            sortable: true,
          },
          {
            key: "rowNumber",
            label: this.$t("messages.general.seqOrder"),
            thClass: "align-middle",
            thStyle: "width: 50px",
            sortable: true,
          },
          {
            key: "OFFICERCODE",
            label: this.$t("messages.general.identity"),
            thClass: "align-middle",
            thStyle: "width: 120px",
            sortable: true,
          },
          {
            key: "NAME",
            label: this.$t("messages.general.fullname"),
            thClass: "align-middle",
            thStyle: "width: 250px",
            tdClass: "text-left text-nowarp",
            sortable: true,
          },
          {
            key: "FACULTYNAME",
            label: this.$t("messages.general.underFac"),
            thClass: "align-middle",
            thStyle: "width: 150px",
            tdClass: "text-center text-nowarp",
            sortable: true,
          },
          {
            key: "GENDER",
            label: this.$t("messages.general.gender"),
            thClass: "align-middle",
            thStyle: "width: 150px",
            tdClass: "text-center text-nowarp",
            sortable: true,
          },
        ],
      },
      perPageOptions: [
        { value: 10, text: 10 },
        { value: 50, text: 50 },
        { value: 100, text: 100 },
        { value: 500, text: 500 },
        { value: 1000, text: 1000 },
        { value: 2000, text: 2000 },
        { value: 3000, text: 3000 },
      ],
      perPage: 100,
      perPageStudentReg: 50,
      currentPage: 1,
      currentPageProgram: 1,
      searched: false,
      selected: false,
      selectedIdx: 0,
      selectedClsId: 0,
      isEdit: false,
      isSpecial: false,
      selectedDetail: false,
      dialogConfirmSuccess: false,
      successText: "",
      dialogError: false,
      errorText: "",
      dialogErrorTitle: "",
      confirmType: 0,
      totalRequest: 0,
      totalConfirm: "",
      currentPageStudentReg: 1,
      studentIdList: [],
      studentList: [],
      totalSumSeat: "",
      isEditTotalSumSeat: false,
      totalConfirmDisabled: false,
    };
  },
  computed: {
    ...mapGetters("application", {
      appInfo: "getUserInfo",
      token: "getToken",
      userId: "getUserId",
      mfuUserId: "getMfuUserId",
    }),
    currentLang: function() {
      return this.appInfo.currentLocale;
    },
  },
  mounted() {
    this.tokenHealthChk();
    this.togglePreLoader(true);
    this.selYear = this.appInfo.data.ENROLL_ACADYEAR;
    this.selSemester = this.appInfo.data.ENROLL_SEMESTER;
    this.dlgSelYear = this.appInfo.data.ENROLL_ACADYEAR;
    this.dlgSelSemester = this.appInfo.data.ENROLL_SEMESTER;
    this.selLvl = 3;
    this.selSection = "00";
    this.togglePreLoader(false);
  },
  methods: {
    ...mapActions("application", ["togglePreLoader", "tokenHealthChk"]),
    onSelYearChanged(event) {
      this.selYear = parseInt(event.target.value);
      // this.getSections();
    },
    onSelSemesterChanged(event) {
      this.selSemester = parseInt(event.target.value);
      // this.getSections();
    },
    onDlgSelYearChanged(event) {
      this.dlgSelYear = parseInt(event.target.value);
      // this.getSections();
    },
    onDlgSelSemesterChanged(event) {
      this.dlgSelSemester = parseInt(event.target.value);
      // this.getSections();
    },
    onSelUnderFacChanged(event) {
      this.selunderFac = parseInt(event.target.value);
      this.getSections();
    },
    handleChkAllPersonel(e) {
      const isChecked = e.target.checked;
      this.bTablePersonnel.items.map((i) => {
        i.action = e.target.checked;
        if (isChecked) {
          this.personelList.push(i.OFFICERCODE);
        }
      });
      if (!isChecked) {
        this.personelList = [];
      }
    },
    handleChkPersonel(e, data) {
      const isChecked = e.target.checked;
      const { item, index } = data;
      this.bTablePersonnel.items[index].action = isChecked;
      if (isChecked) {
        this.personelList.push(item.OFFICERCODE);
      } else {
        const newArr = this.personelList.filter((s) => s != item.OFFICERCODE);
        this.personelList = newArr;
      }
      console.log("personelList", this.personelList);
    },
    handleDelChkAll(e) {
      const isChecked = e.target.checked;
      this.bTableSelectPersonnel.items.map((i) => {
        i.actionSelpersonel = e.target.checked;
        if (isChecked) {
          this.personelSelList.push(i.OFFICERID);
        }
      });
      if (!isChecked) {
        this.personelSelList = [];
      }
    },
    handleDelChk(e, data) {
      const isChecked = e.target.checked;
      const { item, index } = data;
      this.bTableSelectPersonnel.items[index].actionSelpersonel = isChecked;
      if (isChecked) {
        this.personelSelList.push(item.OFFICERID);
      } else {
        const newArr = this.personelSelList.filter((s) => s != item.OFFICERID);
        this.personelSelList = newArr;
      }
      console.log("personelSelList", this.personelSelList);
    },
    async handleSearchPersonel() {
      this.togglePreLoader(true);
      const result = await enrollProvider.getCoordinatorbyofficeryear({
        token: this.token,
        request: {
          officercode: this.dlgIdentity,
          officername: this.dlgFullname,
          facultyid: this.selunderFac,
          lang: this.currentLang,
        },
      });
      console.log("handleSearchPersonel result", result);
      this.bTablePersonnel.items = [];
      if (result.length > 0) {
        let idx = 0;
        const temp = result.map((d, idx) => {
          return {
            ...d,
            rowNumber: idx + 1,
          };
        });
        this.bTablePersonnel.items = temp;
      }
      this.togglePreLoader(false);
    },
    async getReqConfirmDetail() {
      this.togglePreLoader(true);
      const result = await enrollProvider.getCoordinatoryear({
        token: this.token,
        request: {
          acadyear: this.selYear,
          semester: this.selSemester,
          lang: this.currentLang,
        },
      });
      this.bTableSelectPersonnel.items = [];
      if (result.length > 0) {
        const temp = result.map((d, idx) => {
          return {
            ...d,
            rowNumber: idx + 1,
          };
        });
        this.bTableSelectPersonnel.items = temp;
      }
      this.togglePreLoader(false);
    },
    async deleteDataPersonal() {
      this.togglePreLoader(true);
      console.log("this.personelSelList", this.personelSelList);
      let listErrMsg = "";
      let resMsg = "";
      for (let i = 0; i < this.personelSelList.length; i++) {
        const item = this.personelSelList[i];
        const res = await enrollProvider.deleteCoordinatoryear({
          token: this.token,
          request: {
            officerid: item,
            acadyear: this.selYear,
            semester: this.selSemester,
            lang: this.currentLang,
          },
        });
        if (res.status != 200) {
          listErrMsg += `${res.message}<br/>`;
        } else {
          resMsg = `${res.message}<br/>`;
        }
      }
      this.togglePreLoader(false);
      if (listErrMsg != "") {
        this.dialogErrorTitle = "";
        this.dialogError = true;
        this.errorText = `${listErrMsg}`;
      } else {
        this.dialogConfirmSuccess = true;
        this.successText = `${resMsg}`;
        this.getReqConfirmDetail();
      }
    },
    async handelSelCopy() {
      this.dialogCopyFacSem = false;
      this.togglePreLoader(true);
      const result = await enrollProvider.getCoordinatoryear({
        token: this.token,
        request: {
          acadyear: this.dlgSelYear,
          semester: this.dlgSelSemester,
          lang: this.currentLang,
        },
      });
      const req = {
        token: this.token,
        request: {
          acadyear: this.selYear,
          semester: this.selSemester,
          coordinatorlist: result.map((t) => t.OFFICERID),
          userid: this.mfuUserId,
          lang: this.currentLang,
        },
      };
      console.log("req", req);
      const res = await enrollProvider.postCoordinatoryear(req);
      this.togglePreLoader(false);
      if (res.status == 200) {
        this.dialogConfirmSuccess = true;
        this.successText = `${res.message}<br/>`;
      } else {
        this.dialogErrorTitle = "";
        this.dialogError = true;
        this.errorText = `${res.message}<br/>`;
      }
    },
    handleSelectPersonnel() {
      this.dialogSelectPersonnel = true;
      this.dlgFullname = "";
      this.dlgIdentity = "";
      this.selunderFac = 0;
      this.handleSearchPersonel();
    },
    handleCopyData() {
      this.dialogCopyFacSem = true;
    },
    handleClearScreen() {
      this.selYear = this.appInfo.data.ENROLL_ACADYEAR;
      this.selSemester = this.appInfo.data.ENROLL_SEMESTER;
      this.selected = false;
      this.searched = false;
      this.selectedIdx = 0;
      this.bTable.items = [];
    },
    async handleSelPersonnel(isClose) {
      this.dialogSelectPersonnel = false;
      if (!isClose) {
        const temp = this.bTablePersonnel.items.filter((i) => {
          const found = this.personelList.filter((p) => p == i.OFFICERCODE);
          return found.length > 0;
        });
        this.togglePreLoader(true);
        const res = await enrollProvider.postCoordinatoryear({
          token: this.token,
          request: {
            acadyear: this.selYear,
            semester: this.selSemester,
            coordinatorlist: temp.map((t) => t.OFFICERID),
            userid: this.mfuUserId,
            lang: this.currentLang,
          },
        });
        this.togglePreLoader(false);
        if (res.status == 200) {
          this.dialogConfirmSuccess = true;
          this.successText = `${res.message}<br/>`;
          this.getReqConfirmDetail();
        } else {
          this.dialogErrorTitle = "";
          this.dialogError = true;
          this.errorText = `${res.message}<br/>`;
        }
      }
      this.personelList = [];
    },
    goTo(item, index, mode) {
      if (this.selYear != 0 && this.selSemester != 0) {
        this.mode = mode;
        if (mode == "edit") {
          this.getReqConfirmDetail();
          this.personelList = [];
          this.personelSelList = [];
        } else {
          console.log("increase");
        }
      }
    },
    goBack() {
      this.selected = false;
      this.selectedIdx = 0;
      this.selectedDetail = false;
      this.isEdit = false;
      this.mode = "";
    },
  },
  watch: {
    currentLang() {
      this.bTable.fields = [
        {
          key: "action",
          label: "",
          thClass: "align-middle",
          thStyle: "width: 50px",
          sortable: true,
        },
        {
          key: "rowNumber",
          label: this.$t("messages.general.seqOrder"),
          thClass: "align-middle",
          thStyle: "width: 80px",
          sortable: true,
        },
        {
          key: "ACADYEAR",
          label: this.$t("messages.general.academicYear"),
          thClass: "align-middle",
          tdClass: "text-center text-nowarp",
          sortable: true,
        },
        {
          key: "SEMESTER",
          label: this.$t("messages.general.semester"),
          thClass: "align-middle",
          tdClass: "text-center text-nowarp",
          sortable: true,
        },
      ];
      this.bTablePersonnel.fields = [
        {
          key: "action",
          label: "",
          thClass: "align-middle",
          thStyle: "width: 80px",
          sortable: true,
        },
        {
          key: "rowNumber",
          label: this.$t("messages.general.seqOrder"),
          thClass: "align-middle",
          thStyle: "width: 50px",
          sortable: true,
        },
        {
          key: "OFFICERCODE",
          label: this.$t("messages.general.identity"),
          thClass: "align-middle",
          thStyle: "width: 120px",
          sortable: true,
        },
        {
          key: "NAME",
          label: this.$t("messages.general.fullname"),
          thClass: "align-middle",
          thStyle: "width: 250px",
          tdClass: "text-left text-nowarp",
          sortable: true,
        },
        {
          key: "FACULTYNAME",
          label: this.$t("messages.general.underFac"),
          thClass: "align-middle",
          thStyle: "width: 150px",
          tdClass: "text-center text-nowarp",
          sortable: true,
        },
        {
          key: "GENDER",
          label: this.$t("messages.general.gender"),
          thClass: "align-middle",
          thStyle: "width: 150px",
          tdClass: "text-center text-nowarp",
          sortable: true,
        },
      ];
      this.bTableSelectPersonnel.fields = [
        {
          key: "rowNumber",
          label: this.$t("messages.general.seqOrder"),
          thClass: "align-middle",
          thStyle: "width: 50px",
          sortable: true,
        },
        {
          key: "OFFICERCODE",
          label: this.$t("messages.general.identity"),
          thClass: "align-middle",
          thStyle: "width: 120px",
          sortable: true,
        },
        {
          key: "NAME",
          label: this.$t("messages.general.fullname"),
          thClass: "align-middle",
          thStyle: "width: 250px",
          tdClass: "text-left text-nowarp",
          sortable: true,
        },
        {
          key: "FACULTYNAME",
          label: this.$t("messages.general.underFac"),
          thClass: "align-middle",
          thStyle: "width: 150px",
          tdClass: "text-center text-nowarp",
          sortable: true,
        },
        {
          key: "GENDER",
          label: this.$t("messages.general.gender"),
          thClass: "align-middle",
          thStyle: "width: 150px",
          tdClass: "text-center text-nowarp",
          sortable: true,
        },
        {
          key: "actionSelpersonel",
          label: "",
          thClass: "align-middle",
          thStyle: "width: 80px",
          sortable: true,
        },
      ];
      this.getReqConfirmDetail();
    },
  },
};
</script>
